import React, { useState, useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import './App.css';
import './styles'; // Import global styles
import Navbar from './components/common/NavBar/NavBar';
import ProtectedRoute from './components/ProtectedRoute';
import Academy from './pages/Academy/Academy';
import Activities from './pages/Activities/Activities';
import Home from './pages/Home/Home';
import Profile from './pages/Profile/Profile';
import SignIn from './pages/Auth/SignIn';
import MemberProfile from './pages/Profile/MemberProfile';
import AdminDashboard from './pages/Admin/AdminDashboard';
import PartnershipForm from './pages/Partnerships/PartnershipForm';
import About from './pages/About/About';
import ActivityPage from './pages/Activities/ActivityPage';
import EventPage from './pages/Events/EventPage';
import PasswordProtection from './components/features/Auth/PasswordProtection';
import GroupsAndClubs from './pages/Groups/GroupsAndClubs';
import Publications from './pages/Publications/Publications';
import Projects from './pages/Projects/Projects';
import ProjectDetails from './pages/Projects/ProjectDetails';
import AdminProjectForm from './components/features/Admin/AdminProjectForm';
import MinimalFooter from './components/common/Layout/MinimalFooter';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import LogViewer from './pages/Admin/LogViewer';
import AdminMembers from './components/admin/AdminMembers';
import PartnershipApplications from './pages/Partnerships/PartnershipApplications';
import AcademyApplications from './components/admin/AcademyApplications';
import ThinkTank from './pages/ThinkTank/ThinkTank';
import OfflineIndicator from './components/common/OfflineIndicator';
import AuthActionHandler from './pages/Auth/AuthActionHandler';
import AdminUsersSettings from './components/admin/AdminSettings';
import Members from './pages/Members/Members';
function App() {
    // const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [hasPreviewAccess, setHasPreviewAccess] = useState(false);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        // Initialize Google Analytics
        // initGA(process.env.REACT_APP_GA_TRACKING_ID);
        
        // Check for preview access
        const previewAccess = localStorage.getItem('previewAccess');
        setHasPreviewAccess(previewAccess === 'granted');

        // Check for user authentication
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            // setIsAuthenticated(!!user);
            setLoading(false);
            // if (user) {
            //     logger.info('User authenticated', { userId: user.uid, email: user.email });
            // }
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div className="loading-screen">Loading...</div>;
    }

    // First check preview access
    if (!hasPreviewAccess) {
        return <PasswordProtection onAuthenticate={() => setHasPreviewAccess(true)} />;
    }

    // Now the regular app with authentication
    return (
        <ErrorBoundary>
            <AuthProvider>
                <Router>
                    <div className="App">
                        <Navbar />
                        <OfflineIndicator />
                        <main className="main-content">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/sign-in" element={<SignIn />} />
                                {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
                                {/* <Route path="/email-verification" element={<EmailVerificationSuccess />} /> */}
                                <Route path="/auth-action-handler" element={<AuthActionHandler />} />
                                
                                {/* Public Routes */}
                                <Route path="/activities" element={<Activities />} />
                                <Route path="/activities/:activityId" element={<ActivityPage />} />
                                <Route path="/events/:eventId" element={<EventPage />} />
                                {/* <Route path="/events" element={<Events />} /> */}
                                <Route path="/publications" element={<Publications />} />
                                <Route path="/projects" element={<Projects />} />
                                <Route path="/projects/:projectId" element={<ProjectDetails />} />
                                <Route path="/academy" element={<Academy />} />
                                <Route path="/think-tank" element={<ThinkTank />} />
                                <Route path="/groups-and-clubs" element={<GroupsAndClubs />} />
                                
                                {/* Protected User Routes */}
                                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                                <Route path="/members" element={<Members />} />
                                <Route path="/member/:id" element={<ProtectedRoute><MemberProfile /></ProtectedRoute>} />
                                <Route path="/partnerships" element={<PartnershipForm />} />
                                <Route path="/partnerships/applications" element={<ProtectedRoute><PartnershipApplications /></ProtectedRoute>} />
                                <Route path="/partnership-form" element={<PartnershipForm />} />

                                {/* Admin Routes */}
                                <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
                                <Route path="/admin/users" element={<ProtectedRoute requireSuperAdmin><AdminUsersSettings /></ProtectedRoute>} />
                                <Route path="/admin/members" element={<ProtectedRoute requireAdmin><AdminMembers /></ProtectedRoute>} />
                                <Route path="/admin/projects" element={<ProtectedRoute requireAdmin><AdminProjectForm /></ProtectedRoute>} />
                                <Route path="/admin/logs" element={<ProtectedRoute requireSuperAdmin><LogViewer /></ProtectedRoute>} />
                                <Route path="/admin/partnership-applications" element={<ProtectedRoute requireAdmin><PartnershipApplications /></ProtectedRoute>} />
                                <Route path="/admin/academy-applications" element={<ProtectedRoute requireAdmin><AcademyApplications /></ProtectedRoute>} />
                                
                                {/* Catch-all route */}
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </main>
                        <MinimalFooter />
                    </div>
                </Router>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;